import React from 'react'

const D2DEmptyState = ({ width = '248', height = '192', fill = 'none' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 248 192"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M243.877 120.438C244.114 116.841 244.01 113.232 243.549 109.654C241.393 92.8458 231.626 76.9986 217.247 65.8138C212.119 61.8228 206.28 58.2506 202.945 52.9846C197.322 44.1156 197.748 33.9224 190.771 25.1642C183.787 16.3999 173.608 9.55725 162.132 6.0466C127.904 -4.42375 79.9887 12.6245 84.3072 49.0243C84.3212 49.1537 84.3421 49.3446 84.3561 49.5848C84.9282 57.1481 78.2097 63.5042 69.6493 63.6828C38.073 64.3418 10.892 85.8369 5.07348 113.06C1.33399 130.57 7.45949 149.761 21.9639 162.147C32.7917 171.392 47.324 176.473 61.8634 179.959C91.0118 186.956 121.681 188.422 151.737 185.749C179.866 183.242 209.545 176.104 227.733 156.998C237.445 146.805 243.005 133.736 243.877 120.438Z"
        fill="white"
      />
      <rect
        x="170"
        y="38"
        width="72.4022"
        height="150.235"
        rx="8"
        fill="#E2E2FC"
      />
      <rect
        x="180.655"
        y="46.845"
        width="51.0916"
        height="49.2816"
        rx="7.3"
        stroke="#1D2943"
        stroke-width="1.4"
      />
      <rect
        x="180.655"
        y="107.482"
        width="51.0916"
        height="71.0022"
        rx="7.3"
        stroke="#1D2943"
        stroke-width="1.4"
      />
      <rect
        x="233.955"
        y="109.497"
        width="13.8771"
        height="6.03352"
        rx="3.01676"
        transform="rotate(-90 233.955 109.497)"
        fill="#9090C7"
      />
      <rect
        x="224.905"
        y="99.2402"
        width="13.2737"
        height="3.62011"
        rx="1.81006"
        fill="#1D2943"
      />
      <path
        d="M128.151 34.7252V40.3605H115.447L120.696 31.165L128.151 34.7252Z"
        fill="#C9A2A3"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M128.152 40.36V34.7247L120.847 31.1675V32.4409C120.847 33.2551 121.041 34.0576 121.413 34.782C121.786 35.5064 122.326 36.1319 122.988 36.6068L128.152 40.36Z"
        fill="#1D2943"
      />
      <path
        d="M119.162 28.1078V25.3196C119.162 24.6664 119.347 24.0265 119.696 23.4739C120.045 22.9213 120.544 22.4785 121.134 22.1969L125.095 20.3057C125.501 20.1121 125.944 20.008 126.394 20.0004C126.844 19.9929 127.29 20.0821 127.702 20.2619C128.114 20.4418 128.483 20.7081 128.783 21.0428C129.083 21.3775 129.307 21.7727 129.441 22.2016L129.813 23.4098L119.162 28.1078Z"
        fill="#004360"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.162 28.1079L133.633 21.7222"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.104 32.3458H121.002L121.344 33.4852C121.471 33.9085 121.731 34.2797 122.086 34.5433C122.441 34.8069 122.872 34.9488 123.315 34.948H128.374C128.731 34.9479 129.083 34.8724 129.408 34.7263C129.734 34.5802 130.024 34.3669 130.261 34.1005C130.497 33.8341 130.674 33.5207 130.78 33.1808C130.887 32.841 130.919 32.4826 130.877 32.1292L129.821 23.4126L119.664 27.8652H119.105C118.514 27.865 117.947 28.0974 117.527 28.512C117.107 28.9267 116.867 29.4901 116.86 30.0799C116.857 30.3762 116.913 30.6702 117.024 30.9449C117.135 31.2196 117.3 31.4696 117.509 31.6803C117.717 31.891 117.966 32.0583 118.24 32.1726C118.513 32.2868 118.807 32.3456 119.104 32.3458Z"
        fill="#C9A2A3"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.627 28.0955C119.732 28.0955 119.836 28.1162 119.933 28.1562C120.03 28.1963 120.118 28.2551 120.192 28.3291C120.266 28.4032 120.325 28.4911 120.365 28.5878C120.405 28.6846 120.425 28.7882 120.425 28.8929V30.1401H120.668C120.989 30.1401 121.297 30.0129 121.524 29.7863C121.751 29.5597 121.878 29.2524 121.878 28.932V28.4478C121.878 28.1538 121.955 27.8649 122.101 27.6095C122.247 27.3542 122.457 27.1412 122.71 26.9914L124.687 25.8223L119.627 28.0955Z"
        fill="#1D2943"
      />
      <path
        d="M130.017 25.9094C130.017 25.9094 127.752 25.5943 127.473 26.6863C127.299 27.3638 129.417 30.7626 127.796 30.7626"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M125.291 29.0725C125.536 29.0725 125.734 28.8025 125.734 28.4694C125.734 28.1363 125.536 27.8662 125.291 27.8662C125.046 27.8662 124.848 28.1363 124.848 28.4694C124.848 28.8025 125.046 29.0725 125.291 29.0725Z"
        fill="#1D2943"
      />
      <path
        d="M129.421 29.0725C129.665 29.0725 129.864 28.8025 129.864 28.4694C129.864 28.1363 129.665 27.8662 129.421 27.8662C129.176 27.8662 128.978 28.1363 128.978 28.4694C128.978 28.8025 129.176 29.0725 129.421 29.0725Z"
        fill="#1D2943"
      />
      <path
        d="M119.653 30.1405C119.653 29.8311 119.53 29.5345 119.31 29.3157C119.091 29.097 118.794 28.9741 118.484 28.9741"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M127.466 32.1045C127.466 32.1045 125.604 32.1045 125.615 31.1919"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M155.674 65.054C154.865 64.447 154.312 63.5602 154.125 62.5675L151.878 50.7716C151.313 47.8416 149.743 45.1997 147.439 43.2998C145.134 41.3999 142.239 40.3607 139.25 40.3608H106.335C103.236 40.3609 100.183 41.1175 97.4441 42.5648C94.7047 44.0121 92.3614 46.1061 90.6181 48.6644L76.8925 68.8071C74.9669 71.6341 74.2526 74.7681 74.5108 77.753C74.9631 82.9882 79.4167 86.9775 84.6801 86.9775H86.4243L96.9809 74.1809C95.983 73.9626 95.4785 73.0595 96.0002 72.2779L102.218 62.9639C103.245 61.4268 105.584 61.6972 106.234 63.4244L113.548 82.1209C113.548 82.1209 143.802 82.1209 143.803 82.1268L155.674 65.054Z"
        fill="white"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M89.6841 52.7966L87.3831 55.0938L89.6841 57.3909L91.9851 55.0938L89.6841 52.7966Z"
        fill="#004360"
      />
      <path
        d="M87.881 55.0948L85.5799 57.392L85.0388 56.8518L86.9017 54.1172L87.6324 54.8467L87.881 55.0948Z"
        fill="#004360"
      />
      <path
        d="M93.7886 52.7966L91.4875 55.0938L93.7886 57.3909L96.0896 55.0938L93.7886 52.7966Z"
        fill="#004360"
      />
      <path
        d="M97.9685 52.7966L95.6675 55.0938L97.9685 57.3909L100.27 55.0938L97.9685 52.7966Z"
        fill="#004360"
      />
      <path
        d="M102.074 52.7966L99.7729 55.0938L102.074 57.3909L104.375 55.0938L102.074 52.7966Z"
        fill="#004360"
      />
      <path
        d="M106.178 52.7966L103.877 55.0938L106.178 57.3909L108.48 55.0938L106.178 52.7966Z"
        fill="#004360"
      />
      <path
        d="M110.283 52.7966L107.982 55.0938L110.283 57.3909L112.584 55.0938L110.283 52.7966Z"
        fill="#004360"
      />
      <path
        d="M114.463 52.7966L112.162 55.0938L114.463 57.3909L116.764 55.0938L114.463 52.7966Z"
        fill="#004360"
      />
      <path
        d="M118.567 52.7966L116.266 55.0938L118.567 57.3909L120.868 55.0938L118.567 52.7966Z"
        fill="#004360"
      />
      <path
        d="M122.598 52.7971L120.297 55.0942L122.598 57.3914L124.899 55.0942L122.598 52.7971Z"
        fill="#004360"
      />
      <path
        d="M126.704 52.7971L124.403 55.0942L126.704 57.3914L129.005 55.0942L126.704 52.7971Z"
        fill="#004360"
      />
      <path
        d="M130.884 52.7971L128.583 55.0942L130.884 57.3914L133.185 55.0942L130.884 52.7971Z"
        fill="#004360"
      />
      <path
        d="M134.989 52.7971L132.688 55.0942L134.989 57.3914L137.29 55.0942L134.989 52.7971Z"
        fill="#004360"
      />
      <path
        d="M139.094 52.7971L136.793 55.0942L139.094 57.3914L141.395 55.0942L139.094 52.7971Z"
        fill="#004360"
      />
      <path
        d="M143.199 52.7966L140.898 55.0938L143.199 57.3909L145.5 55.0938L143.199 52.7966Z"
        fill="#004360"
      />
      <path
        d="M147.378 52.7971L145.077 55.0942L147.378 57.3914L149.679 55.0942L147.378 52.7971Z"
        fill="#004360"
      />
      <path
        d="M152.875 56.0028L151.484 57.3917L149.183 55.0946L151.484 52.7974L151.62 52.9337L152.448 53.7601L152.875 56.0028Z"
        fill="#004360"
      />
      <path
        d="M91.9849 50.7728L89.6839 53.07L88.4524 51.8405L90.3153 49.106L91.7364 50.5247L91.9849 50.7728Z"
        fill="#004360"
      />
      <path
        d="M93.7891 48.4748L91.488 50.772L93.7891 53.0692L96.0901 50.772L93.7891 48.4748Z"
        fill="#004360"
      />
      <path
        d="M97.969 48.4743L95.668 50.7715L97.969 53.0687L100.27 50.7715L97.969 48.4743Z"
        fill="#004360"
      />
      <path
        d="M102.074 48.4743L99.7729 50.7715L102.074 53.0687L104.375 50.7715L102.074 48.4743Z"
        fill="#004360"
      />
      <path
        d="M106.178 48.4753L103.877 50.7725L106.178 53.0696L108.48 50.7725L106.178 48.4753Z"
        fill="#004360"
      />
      <path
        d="M110.284 48.4748L107.983 50.772L110.284 53.0692L112.585 50.772L110.284 48.4748Z"
        fill="#004360"
      />
      <path
        d="M114.463 48.4743L112.162 50.7715L114.463 53.0687L116.764 50.7715L114.463 48.4743Z"
        fill="#004360"
      />
      <path
        d="M118.569 48.4748L116.268 50.772L118.569 53.0692L120.87 50.772L118.569 48.4748Z"
        fill="#004360"
      />
      <path
        d="M122.599 48.4748L120.298 50.772L122.599 53.0692L124.9 50.772L122.599 48.4748Z"
        fill="#004360"
      />
      <path
        d="M126.704 48.4748L124.403 50.772L126.704 53.0692L129.005 50.772L126.704 48.4748Z"
        fill="#004360"
      />
      <path
        d="M130.883 48.4748L128.582 50.772L130.883 53.0692L133.184 50.772L130.883 48.4748Z"
        fill="#004360"
      />
      <path
        d="M134.989 48.4748L132.688 50.772L134.989 53.0692L137.29 50.772L134.989 48.4748Z"
        fill="#004360"
      />
      <path
        d="M139.093 48.4748L136.792 50.772L139.093 53.0692L141.394 50.772L139.093 48.4748Z"
        fill="#004360"
      />
      <path
        d="M143.199 48.4748L140.898 50.772L143.199 53.0692L145.5 50.772L143.199 48.4748Z"
        fill="#004360"
      />
      <path
        d="M147.378 48.4748L145.077 50.772L147.378 53.0692L149.679 50.772L147.378 48.4748Z"
        fill="#004360"
      />
      <path
        d="M152.183 52.3721L151.484 53.0703L149.183 50.7731L151.286 48.6733C151.543 49.3548 151.741 50.0567 151.878 50.7716L152.183 52.3721Z"
        fill="#004360"
      />
      <path
        d="M96.0913 46.5257L93.7902 48.8229L91.9243 46.9601C92.6327 46.1373 93.4108 45.3769 94.25 44.6875L95.8793 46.3141L96.0913 46.5257Z"
        fill="#004360"
      />
      <path
        d="M97.9685 44.2277L95.6675 46.5249L97.9685 48.8221L100.27 46.5249L97.9685 44.2277Z"
        fill="#004360"
      />
      <path
        d="M102.074 44.2277L99.7727 46.5249L102.074 48.8221L104.375 46.5249L102.074 44.2277Z"
        fill="#004360"
      />
      <path
        d="M106.178 44.2277L103.877 46.5249L106.178 48.8221L108.48 46.5249L106.178 44.2277Z"
        fill="#004360"
      />
      <path
        d="M110.284 44.2277L107.983 46.5249L110.284 48.8221L112.585 46.5249L110.284 44.2277Z"
        fill="#004360"
      />
      <path
        d="M114.463 44.2277L112.162 46.5249L114.463 48.8221L116.764 46.5249L114.463 44.2277Z"
        fill="#004360"
      />
      <path
        d="M118.567 44.2277L116.266 46.5249L118.567 48.8221L120.868 46.5249L118.567 44.2277Z"
        fill="#004360"
      />
      <path
        d="M122.598 44.2277L120.297 46.5249L122.598 48.8221L124.899 46.5249L122.598 44.2277Z"
        fill="#004360"
      />
      <path
        d="M126.704 44.2282L124.403 46.5254L126.704 48.8226L129.005 46.5254L126.704 44.2282Z"
        fill="#004360"
      />
      <path
        d="M130.884 44.2277L128.583 46.5249L130.884 48.8221L133.185 46.5249L130.884 44.2277Z"
        fill="#004360"
      />
      <path
        d="M134.989 44.2277L132.688 46.5249L134.989 48.8221L137.29 46.5249L134.989 44.2277Z"
        fill="#004360"
      />
      <path
        d="M139.094 44.2277L136.793 46.5249L139.094 48.8221L141.395 46.5249L139.094 44.2277Z"
        fill="#004360"
      />
      <path
        d="M143.199 44.2282L140.898 46.5254L143.199 48.8226L145.5 46.5254L143.199 44.2282Z"
        fill="#004360"
      />
      <path
        d="M147.378 44.2277L145.077 46.5249L147.378 48.8221L149.679 46.5249L147.378 44.2277Z"
        fill="#004360"
      />
      <path
        d="M151.257 48.5964L149.183 46.5258L149.822 45.8872C150.408 46.7294 150.89 47.639 151.257 48.5964Z"
        fill="#004360"
      />
      <path
        d="M100.271 42.2045L97.9703 44.5017L96.5396 43.0748C97.5255 42.482 98.5638 41.9807 99.6414 41.5771L100.021 41.9564L100.271 42.2045Z"
        fill="#004360"
      />
      <path
        d="M104.377 42.2039L102.075 44.5011L99.7744 42.2039L100.794 41.1846C101.469 40.9786 102.155 40.8106 102.849 40.6816L104.126 41.9558L104.377 42.2039Z"
        fill="#004360"
      />
      <path
        d="M108.481 42.2043L106.18 44.5014L103.879 42.2043L105.715 40.3713C105.921 40.3648 106.128 40.3613 106.335 40.3608H106.633L108.231 41.9561L108.481 42.2043Z"
        fill="#004360"
      />
      <path
        d="M112.585 42.2043L110.284 44.5014L107.983 42.2043L109.829 40.3608H110.738L112.374 41.9934L112.585 42.2043Z"
        fill="#004360"
      />
      <path
        d="M116.764 42.2043L114.463 44.5014L112.162 42.2043L114.009 40.3608H114.918L116.516 41.9561L116.764 42.2043Z"
        fill="#004360"
      />
      <path
        d="M120.87 42.2043L118.569 44.5014L116.268 42.2043L118.114 40.3608H119.023L120.584 41.9189L120.87 42.2043Z"
        fill="#004360"
      />
      <path
        d="M124.901 42.2043L122.6 44.5014L120.299 42.2043L122.145 40.3608H123.054L124.652 41.9561L124.901 42.2043Z"
        fill="#004360"
      />
      <path
        d="M129.005 42.2043L126.704 44.5014L124.403 42.2043L126.25 40.3608H127.159L128.794 41.9934L129.005 42.2043Z"
        fill="#004360"
      />
      <path
        d="M133.185 42.2043L130.884 44.5014L128.583 42.2043L130.43 40.3608H131.339L132.937 41.9561L133.185 42.2043Z"
        fill="#004360"
      />
      <path
        d="M137.29 42.2043L134.989 44.5014L132.688 42.2043L134.534 40.3608H135.443L137.041 41.9561L137.29 42.2043Z"
        fill="#004360"
      />
      <path
        d="M141.396 42.2043L139.095 44.5014L136.794 42.2043L138.641 40.3608H139.251C139.352 40.3608 139.453 40.3608 139.55 40.3646L141.396 42.2043Z"
        fill="#004360"
      />
      <path
        d="M145.502 42.2039L143.201 44.5011L140.9 42.2039L142.367 40.7412C143.286 40.9692 144.176 41.2984 145.022 41.7225L145.502 42.2039Z"
        fill="#004360"
      />
      <path
        d="M148.047 43.8355L147.515 44.3668L147.378 44.5032L145.077 42.206L145.289 41.9951L145.374 41.9102C146.343 42.4355 147.242 43.0826 148.047 43.8355Z"
        fill="#004360"
      />
      <path
        d="M112.585 72.2318L110.495 74.3188L109.203 71.0142L110.284 69.9346L112.585 72.2318Z"
        fill="#004360"
      />
      <path
        d="M114.463 69.9348L112.162 72.2319L114.463 74.5291L116.764 72.2319L114.463 69.9348Z"
        fill="#004360"
      />
      <path
        d="M118.569 69.9348L116.268 72.2319L118.569 74.5291L120.87 72.2319L118.569 69.9348Z"
        fill="#004360"
      />
      <path
        d="M122.674 69.9343L120.373 72.2314L122.674 74.5286L124.975 72.2314L122.674 69.9343Z"
        fill="#004360"
      />
      <path
        d="M126.779 69.9343L124.478 72.2314L126.779 74.5286L129.08 72.2314L126.779 69.9343Z"
        fill="#004360"
      />
      <path
        d="M130.958 69.9348L128.657 72.2319L130.958 74.5291L133.259 72.2319L130.958 69.9348Z"
        fill="#004360"
      />
      <path
        d="M135.063 69.9348L132.762 72.2319L135.063 74.5291L137.364 72.2319L135.063 69.9348Z"
        fill="#004360"
      />
      <path
        d="M139.093 69.9343L136.792 72.2314L139.093 74.5286L141.394 72.2314L139.093 69.9343Z"
        fill="#004360"
      />
      <path
        d="M143.199 69.9333L140.898 72.2305L143.199 74.5277L145.5 72.2305L143.199 69.9333Z"
        fill="#004360"
      />
      <path
        d="M147.378 69.9343L145.077 72.2314L147.378 74.5286L149.679 72.2314L147.378 69.9343Z"
        fill="#004360"
      />
      <path
        d="M151.953 70.4035L150.067 73.115L149.183 72.232L151.484 69.9341L151.953 70.4035Z"
        fill="#004360"
      />
      <path
        d="M108.479 67.9105L108.231 68.1586L108.126 68.2636L107.991 67.9194L107.982 67.9105L107.986 67.9067L107.673 67.105L108.231 67.6623L108.479 67.9105Z"
        fill="#004360"
      />
      <path
        d="M110.284 65.613L107.983 67.9102L110.284 70.2073L112.585 67.9102L110.284 65.613Z"
        fill="#004360"
      />
      <path
        d="M114.463 65.6125L112.162 67.9097L114.463 70.2069L116.764 67.9097L114.463 65.6125Z"
        fill="#004360"
      />
      <path
        d="M118.567 65.6125L116.266 67.9097L118.567 70.2069L120.868 67.9097L118.567 65.6125Z"
        fill="#004360"
      />
      <path
        d="M122.674 65.6125L120.373 67.9097L122.674 70.2069L124.975 67.9097L122.674 65.6125Z"
        fill="#004360"
      />
      <path
        d="M126.779 65.6125L124.478 67.9097L126.779 70.2069L129.08 67.9097L126.779 65.6125Z"
        fill="#004360"
      />
      <path
        d="M130.958 65.6125L128.657 67.9097L130.958 70.2069L133.259 67.9097L130.958 65.6125Z"
        fill="#004360"
      />
      <path
        d="M135.063 65.6125L132.762 67.9097L135.063 70.2069L137.364 67.9097L135.063 65.6125Z"
        fill="#004360"
      />
      <path
        d="M139.093 65.613L136.792 67.9102L139.093 70.2073L141.394 67.9102L139.093 65.613Z"
        fill="#004360"
      />
      <path
        d="M143.199 65.6125L140.898 67.9097L143.199 70.2069L145.5 67.9097L143.199 65.6125Z"
        fill="#004360"
      />
      <path
        d="M147.378 65.6125L145.077 67.9097L147.378 70.2069L149.679 67.9097L147.378 65.6125Z"
        fill="#004360"
      />
      <path
        d="M153.71 67.8362L151.841 70.5648L149.183 67.9107L151.484 65.6128L153.71 67.8362Z"
        fill="#004360"
      />
      <path
        d="M108.482 63.6634L106.933 65.2095L106.235 63.4212C106.057 62.9385 105.717 62.5323 105.272 62.2715L106.179 61.3662L108.482 63.6634Z"
        fill="#004360"
      />
      <path
        d="M110.284 61.3659L107.983 63.6631L110.284 65.9603L112.585 63.6631L110.284 61.3659Z"
        fill="#004360"
      />
      <path
        d="M114.463 61.3659L112.162 63.6631L114.463 65.9603L116.764 63.6631L114.463 61.3659Z"
        fill="#004360"
      />
      <path
        d="M118.569 61.3659L116.268 63.6631L118.569 65.9603L120.87 63.6631L118.569 61.3659Z"
        fill="#004360"
      />
      <path
        d="M122.674 61.3659L120.373 63.6631L122.674 65.9603L124.975 63.6631L122.674 61.3659Z"
        fill="#004360"
      />
      <path
        d="M126.778 61.3659L124.477 63.6631L126.778 65.9603L129.079 63.6631L126.778 61.3659Z"
        fill="#004360"
      />
      <path
        d="M130.958 61.3659L128.657 63.6631L130.958 65.9603L133.259 63.6631L130.958 61.3659Z"
        fill="#004360"
      />
      <path
        d="M135.063 61.3659L132.762 63.6631L135.063 65.9603L137.364 63.6631L135.063 61.3659Z"
        fill="#004360"
      />
      <path
        d="M139.093 61.3654L136.792 63.6626L139.093 65.9598L141.394 63.6626L139.093 61.3654Z"
        fill="#004360"
      />
      <path
        d="M143.199 61.3654L140.898 63.6626L143.199 65.9598L145.5 63.6626L143.199 61.3654Z"
        fill="#004360"
      />
      <path
        d="M147.378 61.3654L145.077 63.6626L147.378 65.9598L149.679 63.6626L147.378 61.3654Z"
        fill="#004360"
      />
      <path
        d="M151.483 61.3654L149.182 63.6626L151.483 65.9598L153.784 63.6626L151.483 61.3654Z"
        fill="#004360"
      />
      <path
        d="M155.24 65.6122L153.288 63.663L154.171 62.7808C154.394 63.6887 154.925 64.4917 155.674 65.0534L155.24 65.6122Z"
        fill="#004360"
      />
      <path
        d="M106.179 57.0436L103.878 59.3408L106.179 61.638L108.48 59.3408L106.179 57.0436Z"
        fill="#004360"
      />
      <path
        d="M110.284 57.0436L107.983 59.3408L110.284 61.638L112.585 59.3408L110.284 57.0436Z"
        fill="#004360"
      />
      <path
        d="M114.463 57.0436L112.162 59.3408L114.463 61.638L116.764 59.3408L114.463 57.0436Z"
        fill="#004360"
      />
      <path
        d="M118.569 57.0436L116.268 59.3408L118.569 61.638L120.87 59.3408L118.569 57.0436Z"
        fill="#004360"
      />
      <path
        d="M122.674 57.0436L120.373 59.3408L122.674 61.638L124.975 59.3408L122.674 57.0436Z"
        fill="#004360"
      />
      <path
        d="M126.779 57.0436L124.478 59.3408L126.779 61.638L129.08 59.3408L126.779 57.0436Z"
        fill="#004360"
      />
      <path
        d="M130.958 57.0436L128.657 59.3408L130.958 61.638L133.259 59.3408L130.958 57.0436Z"
        fill="#004360"
      />
      <path
        d="M135.063 57.0436L132.762 59.3408L135.063 61.638L137.364 59.3408L135.063 57.0436Z"
        fill="#004360"
      />
      <path
        d="M139.093 57.0436L136.792 59.3408L139.093 61.638L141.394 59.3408L139.093 57.0436Z"
        fill="#004360"
      />
      <path
        d="M143.199 57.0436L140.898 59.3408L143.199 61.638L145.5 59.3408L143.199 57.0436Z"
        fill="#004360"
      />
      <path
        d="M147.378 57.0436L145.077 59.3408L147.378 61.638L149.679 59.3408L147.378 57.0436Z"
        fill="#004360"
      />
      <path
        d="M153.555 59.5716L151.484 61.6393L149.183 59.3421L151.484 57.0449L151.658 57.2185L153.447 59.0046L153.536 59.094L153.475 59.1551L153.555 59.5716Z"
        fill="#004360"
      />
      <path
        d="M153.563 59.6163L153.288 59.3413L153.475 59.1543L153.555 59.5708L153.563 59.6163Z"
        fill="#004360"
      />
      <path
        d="M116.764 80.8753L115.517 82.1204H113.546L112.807 80.2315L114.463 78.5781L116.764 80.8753Z"
        fill="#004360"
      />
      <path
        d="M120.87 80.8753L119.623 82.1204H117.515L116.268 80.8753L118.569 78.5781L120.87 80.8753Z"
        fill="#004360"
      />
      <path
        d="M124.975 80.8753L123.727 82.1204H121.62L120.373 80.8753L122.674 78.5781L124.975 80.8753Z"
        fill="#004360"
      />
      <path
        d="M129.08 80.8753L127.832 82.1204H125.725L124.478 80.8753L126.779 78.5781L129.08 80.8753Z"
        fill="#004360"
      />
      <path
        d="M133.259 80.8753L132.012 82.1204H129.904L128.657 80.8753L130.958 78.5781L133.259 80.8753Z"
        fill="#004360"
      />
      <path
        d="M137.364 80.8753L136.117 82.1204H134.009L132.762 80.8753L135.063 78.5781L137.364 80.8753Z"
        fill="#004360"
      />
      <path
        d="M141.395 80.8753L140.148 82.1204H138.04L136.793 80.8753L139.094 78.5781L141.395 80.8753Z"
        fill="#004360"
      />
      <path
        d="M145.01 80.3873L143.812 82.1234L142.145 82.1204L140.898 80.8753L143.199 78.5781L145.01 80.3873Z"
        fill="#004360"
      />
      <path
        d="M112.585 76.5537L111.71 77.427L110.59 74.562L112.374 76.3428L112.585 76.5537Z"
        fill="#004360"
      />
      <path
        d="M114.463 74.256L112.162 76.5532L114.463 78.8504L116.764 76.5532L114.463 74.256Z"
        fill="#004360"
      />
      <path
        d="M118.569 74.256L116.268 76.5532L118.569 78.8504L120.87 76.5532L118.569 74.256Z"
        fill="#004360"
      />
      <path
        d="M122.674 74.256L120.373 76.5532L122.674 78.8504L124.975 76.5532L122.674 74.256Z"
        fill="#004360"
      />
      <path
        d="M126.778 74.256L124.477 76.5532L126.778 78.8504L129.079 76.5532L126.778 74.256Z"
        fill="#004360"
      />
      <path
        d="M130.958 74.256L128.657 76.5532L130.958 78.8504L133.259 76.5532L130.958 74.256Z"
        fill="#004360"
      />
      <path
        d="M135.063 74.256L132.762 76.5532L135.063 78.8504L137.364 76.5532L135.063 74.256Z"
        fill="#004360"
      />
      <path
        d="M139.093 74.2556L136.792 76.5527L139.093 78.8499L141.394 76.5527L139.093 74.2556Z"
        fill="#004360"
      />
      <path
        d="M143.199 74.2556L140.898 76.5527L143.199 78.8499L145.5 76.5527L143.199 74.2556Z"
        fill="#004360"
      />
      <path
        d="M146.611 78.085L145.077 76.5538L147.378 74.2559L148.497 75.3728L146.611 78.085Z"
        fill="#004360"
      />
      <path
        d="M75.4923 72.232L75.2437 72.4802L75.031 72.6925C75.0631 72.5845 75.0967 72.4764 75.1325 72.3691C75.1728 72.2455 75.2146 72.1225 75.2594 71.9966L75.4923 72.232Z"
        fill="#004360"
      />
      <path
        d="M79.5971 72.2321L77.296 74.5293L75.1316 72.3684C75.1719 72.2447 75.2137 72.1218 75.2585 71.9959L75.2428 71.9802L75.2764 71.9467L77.1587 70.0675L77.2953 69.9312L79.5971 72.2321Z"
        fill="#004360"
      />
      <path
        d="M81.4734 69.9348L79.1724 72.2319L81.4734 74.5291L83.7744 72.2319L81.4734 69.9348Z"
        fill="#004360"
      />
      <path
        d="M85.5789 69.9348L83.2778 72.2319L85.5789 74.5291L87.8799 72.2319L85.5789 69.9348Z"
        fill="#004360"
      />
      <path
        d="M89.6834 69.9348L87.3823 72.2319L89.6834 74.5291L91.9844 72.2319L89.6834 69.9348Z"
        fill="#004360"
      />
      <path
        d="M96.0536 72.1952L95.9998 72.275C95.9744 72.3137 95.9513 72.3495 95.9304 72.3912L93.7891 74.529L91.488 72.2318L93.7891 69.9346L95.8789 72.0209L96.0536 72.1952Z"
        fill="#004360"
      />
      <path
        d="M96.7505 71.1509L96.0534 72.194L95.9996 72.2738C95.9742 72.3125 95.9511 72.3483 95.9302 72.39C95.9183 72.4124 95.9063 72.4355 95.8959 72.4586L95.6675 72.2306L96.7505 71.1509Z"
        fill="#004360"
      />
      <path
        d="M79.5974 67.9106L77.2963 70.2078L76.5022 69.415C76.6261 69.2108 76.7567 69.0081 76.894 68.807L78.3517 66.667L79.5974 67.9106Z"
        fill="#004360"
      />
      <path
        d="M81.4741 65.6125L79.1731 67.9097L81.4741 70.2069L83.7752 67.9097L81.4741 65.6125Z"
        fill="#004360"
      />
      <path
        d="M85.5789 65.6125L83.2778 67.9097L85.5789 70.2069L87.8799 67.9097L85.5789 65.6125Z"
        fill="#004360"
      />
      <path
        d="M89.6834 65.6125L87.3823 67.9097L89.6834 70.2069L91.9844 67.9097L89.6834 65.6125Z"
        fill="#004360"
      />
      <path
        d="M93.7886 65.6125L91.4875 67.9097L93.7886 70.2069L96.0896 67.9097L93.7886 65.6125Z"
        fill="#004360"
      />
      <path
        d="M99.456 67.0988L97.6155 69.8557L95.6675 67.911L97.9685 65.6138L99.456 67.0988Z"
        fill="#004360"
      />
      <path
        d="M83.7757 63.6636L81.4747 65.9608L79.9021 64.3908L81.765 61.6562L83.7757 63.6636Z"
        fill="#004360"
      />
      <path
        d="M85.5794 61.3654L83.2783 63.6626L85.5794 65.9598L87.8804 63.6626L85.5794 61.3654Z"
        fill="#004360"
      />
      <path
        d="M89.6846 61.3659L87.3835 63.6631L89.6846 65.9603L91.9856 63.6631L89.6846 61.3659Z"
        fill="#004360"
      />
      <path
        d="M93.7893 61.3659L91.4883 63.6631L93.7893 65.9603L96.0903 63.6631L93.7893 61.3659Z"
        fill="#004360"
      />
      <path
        d="M97.969 61.3654L95.668 63.6626L97.969 65.9598L100.27 63.6626L97.969 61.3654Z"
        fill="#004360"
      />
      <path
        d="M102.966 62.2564C102.666 62.4317 102.411 62.6737 102.22 62.9635L100.96 64.8472L99.7729 63.6624L102.074 61.3652L102.966 62.2564Z"
        fill="#004360"
      />
      <path
        d="M85.1779 56.6445L87.8797 59.3419L85.5787 61.639L83.3149 59.3791L85.1779 56.6445Z"
        fill="#004360"
      />
      <path
        d="M89.6846 57.0436L87.3835 59.3408L89.6846 61.638L91.9856 59.3408L89.6846 57.0436Z"
        fill="#004360"
      />
      <path
        d="M93.7891 57.0436L91.488 59.3408L93.7891 61.638L96.0901 59.3408L93.7891 57.0436Z"
        fill="#004360"
      />
      <path
        d="M97.9685 57.0436L95.6675 59.3408L97.9685 61.638L100.27 59.3408L97.9685 57.0436Z"
        fill="#004360"
      />
      <path
        d="M102.074 57.0436L99.7729 59.3408L102.074 61.638L104.375 59.3408L102.074 57.0436Z"
        fill="#004360"
      />
      <path
        d="M75.4926 80.8756L75.362 81.006C75.3097 80.8912 75.2597 80.775 75.2127 80.658C75.197 80.6238 75.1836 80.5887 75.1694 80.5537L75.4926 80.8756Z"
        fill="#004360"
      />
      <path
        d="M75.2112 80.6577L77.2943 78.5781L79.5953 80.8753L76.9704 83.4959L75.2112 80.6577Z"
        fill="#004360"
      />
      <path
        d="M81.4746 78.5773L79.1736 80.8745L81.4746 83.1717L83.7756 80.8745L81.4746 78.5773Z"
        fill="#004360"
      />
      <path
        d="M85.5794 78.5768L83.2783 80.874L85.5794 83.1712L87.8804 80.874L85.5794 78.5768Z"
        fill="#004360"
      />
      <path
        d="M83.7764 85.2718L82.3397 86.7061C81.3218 86.4689 80.3464 86.0771 79.4475 85.5445L79.1743 85.2718L81.4754 82.9746L83.7764 85.2718Z"
        fill="#004360"
      />
      <path
        d="M87.8807 85.2718L87.5918 85.5602L86.1745 86.9751H84.9848L83.2786 85.2718L85.5796 82.9746L85.6789 83.0737L87.853 85.2442L87.8807 85.2718Z"
        fill="#004360"
      />
      <path
        d="M91.6953 80.5855L89.6167 83.1047L87.3835 80.8753L89.6846 78.5781L91.6953 80.5855Z"
        fill="#004360"
      />
      <path
        d="M75.4915 76.554L75.2429 76.8021L74.4965 77.5473C74.4484 76.8862 74.4484 76.2226 74.4965 75.5615L75.2429 76.3066L75.4915 76.554Z"
        fill="#004360"
      />
      <path
        d="M77.2947 74.256L74.9937 76.5532L77.2947 78.8504L79.5957 76.5532L77.2947 74.256Z"
        fill="#004360"
      />
      <path
        d="M81.4734 74.2556L79.1724 76.5527L81.4734 78.8499L83.7744 76.5527L81.4734 74.2556Z"
        fill="#004360"
      />
      <path
        d="M85.5794 74.2565L83.2783 76.5537L85.5794 78.8509L87.8804 76.5537L85.5794 74.2565Z"
        fill="#004360"
      />
      <path
        d="M89.6846 74.256L87.3835 76.5532L89.6846 78.8504L91.9856 76.5532L89.6846 74.256Z"
        fill="#004360"
      />
      <path
        d="M95.5035 75.9679L93.4256 78.4879L91.488 76.5535L93.7891 74.2563L93.9257 74.3927L95.5035 75.9679Z"
        fill="#004360"
      />
      <path
        d="M143.798 82.1201V58.1602"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M128.301 40.1367V56.302L121.069 40.1367H128.301Z"
        fill="#1D2943"
      />
      <path
        d="M133.724 40.1544H128.715V36.7939C129.64 36.8096 130.526 37.1676 131.201 37.7984L133.724 40.1544Z"
        fill="#9090C7"
      />
      <path
        d="M121.293 40.5844L120.49 38.3147C120.377 37.9958 120.168 37.7196 119.891 37.5241C119.614 37.3287 119.284 37.2235 118.945 37.2231H112.794C111.848 37.2232 110.936 37.5825 110.245 38.2283L107.722 40.5844H121.293Z"
        fill="#9090C7"
      />
      <path
        d="M117.279 40.584L119.453 37.9865C119.518 37.9106 119.601 37.8529 119.695 37.8192C119.789 37.7855 119.89 37.777 119.988 37.7945C120.086 37.812 120.178 37.8549 120.254 37.9189C120.331 37.983 120.389 38.0659 120.423 38.1594L121.293 40.584H117.279Z"
        fill="#1D2943"
      />
      <path
        d="M132.248 55.0073H139.546V59.4378C139.545 59.7264 139.43 60.0031 139.226 60.2071C139.021 60.4111 138.744 60.5257 138.455 60.5257H133.335C133.046 60.5257 132.769 60.411 132.564 60.2068C132.36 60.0026 132.245 59.7258 132.245 59.437V55.0073H132.248Z"
        fill="white"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M139.546 53.5225H132.248V55.0067H139.546V53.5225Z"
        fill="white"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M149.447 186.796H130.029C128.404 186.796 127.065 185.499 126.885 183.925H129.771C130.805 183.925 131.829 183.731 132.791 183.353L135.813 182.165C137.628 181.452 139.561 181.086 141.512 181.086H143.802L149.447 186.796Z"
        fill="#1D2943"
      />
      <path
        d="M99.0023 186.795H75.4403C74.6706 186.796 73.9285 186.509 73.3591 185.992C72.7897 185.475 72.434 184.764 72.3616 183.999H79.4035C80.4374 183.999 81.462 183.805 82.4241 183.427L85.4453 182.239C87.2606 181.526 89.1939 181.16 91.1446 181.16H93.5845L99.0023 186.795Z"
        fill="#1D2943"
      />
      <path
        d="M143.803 181.085H141.512C139.561 181.085 137.628 181.451 135.813 182.164L132.792 183.352C131.83 183.729 130.805 183.924 129.771 183.924H126.886C126.871 183.803 126.864 183.682 126.865 183.561V104.515C126.865 103.775 125.846 103.573 125.562 104.256L93.585 181.159H91.1452C89.1945 181.159 87.2611 181.525 85.4459 182.238L82.4246 183.426C81.4626 183.804 80.438 183.998 79.4041 183.998H72.3621C72.3165 183.505 72.3913 183.007 72.5801 182.548L113.547 82.1201H143.799V181.085H143.803Z"
        fill="#1D2943"
      />
      <path
        d="M143.799 82.1201V85.9202H111.996L113.546 82.1201H143.799Z"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M131.4 82.1201H128.44C128.2 82.1201 128.005 82.3143 128.005 82.5538V85.5089C128.005 85.7484 128.2 85.9426 128.44 85.9426H131.4C131.64 85.9426 131.834 85.7484 131.834 85.5089V82.5538C131.834 82.3143 131.64 82.1201 131.4 82.1201Z"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M128.005 84.0205H129.92"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M138.746 82.1201H137.921V85.9202H138.746V82.1201Z"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.729 82.1201H120.904V85.9202H121.729V82.1201Z"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <mask id="path-199-inside-1_241_11808" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.879 61.1148L107.5 58.6533L101.649 91.1618L115.028 93.6232L120.879 61.1148ZM114.911 65.3988C114.739 66.3563 113.837 66.9914 112.895 66.8172C112.098 66.6699 111.773 66.0531 111.477 65.4897C111.302 65.1573 111.137 64.8436 110.891 64.6556C111.154 64.5612 111.393 64.3438 111.649 64.1112C112.125 63.6778 112.66 63.1916 113.516 63.3498C114.458 63.524 115.082 64.4413 114.911 65.3988ZM108.383 64.2238C108.383 64.2238 107.242 63.5572 106.803 62.7791L106.408 64.9855C107.09 64.5483 108.383 64.2238 108.383 64.2238Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.879 61.1148L107.5 58.6533L101.649 91.1618L115.028 93.6232L120.879 61.1148ZM114.911 65.3988C114.739 66.3563 113.837 66.9914 112.895 66.8172C112.098 66.6699 111.773 66.0531 111.477 65.4897C111.302 65.1573 111.137 64.8436 110.891 64.6556C111.154 64.5612 111.393 64.3438 111.649 64.1112C112.125 63.6778 112.66 63.1916 113.516 63.3498C114.458 63.524 115.082 64.4413 114.911 65.3988ZM108.383 64.2238C108.383 64.2238 107.242 63.5572 106.803 62.7791L106.408 64.9855C107.09 64.5483 108.383 64.2238 108.383 64.2238Z"
        fill="white"
      />
      <path
        d="M107.5 58.6533L107.731 57.2723L106.371 57.0222L106.126 58.3826L107.5 58.6533ZM120.879 61.1148L122.253 61.3854L122.504 59.9903L121.11 59.7338L120.879 61.1148ZM101.649 91.1618L100.275 90.8911L100.024 92.2863L101.418 92.5428L101.649 91.1618ZM115.028 93.6232L114.797 95.0042L116.157 95.2544L116.402 93.8939L115.028 93.6232ZM112.895 66.8172L113.127 65.4364L112.895 66.8172ZM114.911 65.3988L113.537 65.1293L113.537 65.1293L114.911 65.3988ZM111.477 65.4897L110.245 66.1313L110.245 66.1313L111.477 65.4897ZM110.891 64.6556L110.404 63.3323L107.995 64.1963L110.058 65.7697L110.891 64.6556ZM111.649 64.1112L112.594 65.1591L112.594 65.1591L111.649 64.1112ZM113.516 63.3498L113.748 61.969L113.516 63.3498ZM106.803 62.7791L108.016 62.1015L106.11 58.7169L105.43 62.5093L106.803 62.7791ZM108.383 64.2238L108.74 65.5863L112.052 64.7546L109.07 63.0124L108.383 64.2238ZM106.408 64.9855L105.034 64.7157L104.461 67.909L107.17 66.1731L106.408 64.9855ZM107.269 60.0343L120.649 62.4958L121.11 59.7338L107.731 57.2723L107.269 60.0343ZM103.022 91.4324L108.874 58.924L106.126 58.3826L100.275 90.8911L103.022 91.4324ZM115.259 92.2422L101.879 89.7807L101.418 92.5428L114.797 95.0042L115.259 92.2422ZM119.506 60.8441L113.654 93.3526L116.402 93.8939L122.253 61.3854L119.506 60.8441ZM112.663 68.198C114.379 68.5152 115.981 67.3613 116.285 65.6683L113.537 65.1293C113.497 65.3514 113.295 65.4675 113.127 65.4364L112.663 68.198ZM110.245 66.1313C110.503 66.6212 111.108 67.9106 112.663 68.198L113.127 65.4364C113.087 65.4291 113.075 65.4209 113.074 65.4206C113.072 65.419 113.057 65.4101 113.029 65.3784C112.998 65.3438 112.956 65.2883 112.9 65.1962C112.842 65.1005 112.786 64.9952 112.709 64.8481L110.245 66.1313ZM110.058 65.7697C110.003 65.7277 110.002 65.7069 110.048 65.778C110.098 65.8536 110.151 65.9517 110.245 66.1313L112.709 64.8481C112.578 64.6005 112.272 63.9604 111.723 63.5415L110.058 65.7697ZM110.704 63.0633C110.566 63.1884 110.487 63.2593 110.417 63.3125C110.35 63.3635 110.351 63.3511 110.404 63.3323L111.377 65.9789C111.95 65.7735 112.4 65.3352 112.594 65.1591L110.704 63.0633ZM113.748 61.969C112.143 61.6724 111.131 62.6742 110.704 63.0633L112.594 65.1591C112.854 64.9224 112.979 64.8187 113.095 64.7583C113.139 64.7354 113.166 64.7285 113.182 64.7258C113.196 64.7234 113.226 64.7199 113.284 64.7306L113.748 61.969ZM116.285 65.6683C116.59 63.9643 115.476 62.2886 113.748 61.969L113.284 64.7306C113.44 64.7594 113.575 64.9184 113.537 65.1293L116.285 65.6683ZM105.591 63.4567C105.956 64.1034 106.539 64.6076 106.915 64.8999C107.122 65.0602 107.31 65.1898 107.448 65.28C107.517 65.3255 107.575 65.3618 107.617 65.3879C107.638 65.4009 107.656 65.4115 107.669 65.4194C107.676 65.4234 107.681 65.4267 107.686 65.4293C107.688 65.4306 107.69 65.4318 107.691 65.4327C107.692 65.4332 107.693 65.4337 107.694 65.4341C107.694 65.4343 107.694 65.4345 107.695 65.4346C107.695 65.4347 107.695 65.4349 107.695 65.4349C107.695 65.435 107.695 65.4352 108.383 64.2238C109.07 63.0124 109.07 63.0125 109.07 63.0126C109.07 63.0126 109.07 63.0127 109.07 63.0128C109.071 63.013 109.071 63.0131 109.071 63.0132C109.072 63.0135 109.072 63.0137 109.072 63.0138C109.073 63.0142 109.073 63.0143 109.073 63.0144C109.073 63.0144 109.072 63.0139 109.07 63.0128C109.067 63.0105 109.059 63.006 109.048 62.9993C109.027 62.9859 108.992 62.9641 108.947 62.9349C108.857 62.8758 108.733 62.7902 108.599 62.6866C108.296 62.451 108.09 62.2329 108.016 62.1015L105.591 63.4567ZM107.782 65.2554L108.177 63.0489L105.43 62.5093L105.034 64.7157L107.782 65.2554ZM108.383 64.2238C108.025 62.8612 108.025 62.8613 108.025 62.8613C108.025 62.8613 108.024 62.8613 108.024 62.8614C108.024 62.8614 108.024 62.8615 108.024 62.8615C108.023 62.8617 108.023 62.8618 108.022 62.862C108.021 62.8623 108.019 62.8627 108.017 62.8632C108.013 62.8642 108.008 62.8655 108.002 62.8671C107.989 62.8704 107.972 62.8749 107.95 62.8806C107.907 62.892 107.847 62.9083 107.773 62.9292C107.626 62.9707 107.423 63.031 107.195 63.1069C106.771 63.2479 106.139 63.4817 105.645 63.798L107.17 66.1731C107.359 66.0522 107.715 65.9051 108.108 65.7745C108.287 65.7146 108.45 65.6665 108.567 65.6334C108.625 65.617 108.671 65.6046 108.701 65.5966C108.716 65.5925 108.727 65.5896 108.734 65.5879C108.737 65.5871 108.74 65.5865 108.741 65.5862C108.741 65.5861 108.741 65.586 108.741 65.586C108.741 65.586 108.741 65.5861 108.741 65.5861C108.741 65.5861 108.741 65.5862 108.741 65.5862C108.741 65.5862 108.741 65.5862 108.741 65.5863C108.74 65.5863 108.74 65.5863 108.383 64.2238Z"
        fill="#1D2943"
        mask="url(#path-199-inside-1_241_11808)"
      />
      <path
        d="M133.384 40.3604L105.158 93.4126H108.629L136.563 40.3604H133.384Z"
        fill="white"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M108.78 93.391L100.017 114.77C99.7643 115.391 99.3312 115.923 98.7736 116.298C98.216 116.673 97.5592 116.873 96.8871 116.873H87.8949C87.5143 116.873 87.1394 116.781 86.8029 116.603C86.4665 116.426 86.1788 116.168 85.9651 115.854C85.7515 115.539 85.6184 115.177 85.5774 114.8C85.5365 114.422 85.5891 114.04 85.7305 113.687L93.071 95.5063C93.3214 94.8806 93.7539 94.3442 94.3126 93.9662C94.8714 93.5882 95.5308 93.386 96.2057 93.3857L108.78 93.391Z"
        fill="white"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M108.78 93.4121L100.144 114.632C99.8955 115.244 99.4693 115.769 98.9202 116.139C98.3711 116.508 97.7241 116.706 97.0618 116.707H93.4979C93.1232 116.707 92.7541 116.615 92.423 116.44C92.092 116.264 91.809 116.01 91.5989 115.701C91.3888 115.391 91.258 115.034 91.2178 114.662C91.1776 114.29 91.2294 113.914 91.3685 113.567L98.6031 95.5044C98.8501 94.8875 99.2767 94.3586 99.8277 93.9861C100.379 93.6135 101.029 93.4144 101.695 93.4143L108.78 93.4121Z"
        fill="white"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M105.047 93.4121L104.835 93.93"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M104.414 94.9658L96.4114 114.632C96.2334 115.069 95.9643 115.463 95.622 115.788C95.2797 116.114 94.872 116.362 94.426 116.518"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
        stroke-dasharray="22.51 22.51"
      />
      <path
        d="M93.8837 116.658C93.6997 116.689 93.5135 116.704 93.3269 116.705"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M96.4504 100.758H91.0183"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <mask id="path-208-inside-2_241_11808" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M205.732 43.3045L192.688 37.7927L179.424 69.5201L192.469 75.0318L205.732 43.3045ZM198.702 46.3186C198.313 47.2533 197.253 47.6957 196.334 47.3068C195.558 46.9777 195.367 46.2777 195.192 45.6383C195.089 45.2611 194.992 44.905 194.784 44.6585C195.072 44.6218 195.364 44.4545 195.677 44.2756C196.258 43.9423 196.911 43.5683 197.746 43.9218C198.664 44.3108 199.092 45.3839 198.702 46.3186ZM192.333 43.6552C192.333 43.6552 191.323 42.7209 191.053 41.8313L190.154 43.9852C190.946 43.6943 192.333 43.6552 192.333 43.6552Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.732 43.3045L192.688 37.7927L179.424 69.5201L192.469 75.0318L205.732 43.3045ZM198.702 46.3186C198.313 47.2533 197.253 47.6957 196.334 47.3068C195.558 46.9777 195.367 46.2777 195.192 45.6383C195.089 45.2611 194.992 44.905 194.784 44.6585C195.072 44.6218 195.364 44.4545 195.677 44.2756C196.258 43.9423 196.911 43.5683 197.746 43.9218C198.664 44.3108 199.092 45.3839 198.702 46.3186ZM192.333 43.6552C192.333 43.6552 191.323 42.7209 191.053 41.8313L190.154 43.9852C190.946 43.6943 192.333 43.6552 192.333 43.6552Z"
        fill="white"
      />
      <path
        d="M192.688 37.7927L193.212 36.4944L191.938 35.9562L191.405 37.232L192.688 37.7927ZM205.732 43.3045L207.015 43.8652L207.562 42.5577L206.256 42.0062L205.732 43.3045ZM179.424 69.5201L178.141 68.9594L177.595 70.2668L178.9 70.8184L179.424 69.5201ZM192.469 75.0318L191.945 76.3302L193.218 76.8684L193.752 75.5925L192.469 75.0318ZM196.334 47.3068L195.809 48.6046L196.334 47.3068ZM198.702 46.3186L197.419 45.7591L198.702 46.3186ZM195.192 45.6383L196.534 45.2779L196.534 45.2779L195.192 45.6383ZM194.784 44.6585L194.595 43.2615L192.056 43.5845L193.73 45.5662L194.784 44.6585ZM195.677 44.2756L194.98 43.0486L194.98 43.0486L195.677 44.2756ZM197.746 43.9218L197.22 45.2196L197.746 43.9218ZM191.053 41.8313L192.383 41.4315L191.253 37.7142L189.769 41.2715L191.053 41.8313ZM192.333 43.6552L192.387 45.0627L195.8 44.9664L193.266 42.6212L192.333 43.6552ZM190.154 43.9852L188.871 43.4254L187.622 46.4185L190.642 45.3093L190.154 43.9852ZM192.164 39.0911L205.208 44.6028L206.256 42.0062L193.212 36.4944L192.164 39.0911ZM180.707 70.0808L193.971 38.3535L191.405 37.232L178.141 68.9594L180.707 70.0808ZM192.993 73.7335L179.949 68.2218L178.9 70.8184L191.945 76.3302L192.993 73.7335ZM204.449 42.7438L191.186 74.4711L193.752 75.5925L207.015 43.8652L204.449 42.7438ZM195.809 48.6046C197.452 49.3007 199.309 48.5025 199.986 46.8781L197.419 45.7591C197.317 46.0041 197.053 46.0907 196.86 46.009L195.809 48.6046ZM193.851 45.9987C194.003 46.5579 194.323 47.975 195.809 48.6046L196.86 46.009C196.815 45.9901 196.799 45.9753 196.793 45.97C196.786 45.963 196.769 45.9457 196.745 45.9026C196.719 45.8562 196.688 45.7867 196.651 45.6784C196.613 45.566 196.579 45.4446 196.534 45.2779L193.851 45.9987ZM193.73 45.5662C193.689 45.5182 193.696 45.5037 193.728 45.5898C193.763 45.681 193.795 45.7955 193.851 45.9987L196.534 45.2779C196.456 44.9931 196.292 44.2881 195.838 43.7508L193.73 45.5662ZM194.98 43.0486C194.813 43.1445 194.714 43.2 194.629 43.2396C194.547 43.2777 194.545 43.2678 194.595 43.2615L194.973 46.0555C195.588 45.9773 196.134 45.6398 196.373 45.5027L194.98 43.0486ZM198.271 42.624C196.735 41.9735 195.505 42.748 194.98 43.0486L196.373 45.5027C196.69 45.3212 196.846 45.2401 196.986 45.2027C197.041 45.1881 197.075 45.1862 197.098 45.1874C197.12 45.1884 197.158 45.1932 197.22 45.2196L198.271 42.624ZM199.986 46.8781C200.667 45.2437 199.925 43.3248 198.271 42.624L197.22 45.2196C197.402 45.2968 197.517 45.524 197.419 45.7591L199.986 46.8781ZM189.723 42.2311C189.944 42.9586 190.416 43.5948 190.732 43.9752C190.905 44.1831 191.066 44.3561 191.185 44.4779C191.244 44.5393 191.295 44.5888 191.331 44.6245C191.35 44.6423 191.365 44.6568 191.376 44.6677C191.382 44.6731 191.387 44.6776 191.391 44.6812C191.393 44.683 191.394 44.6846 191.396 44.6859C191.397 44.6866 191.397 44.6872 191.398 44.6878C191.398 44.688 191.398 44.6883 191.399 44.6885C191.399 44.6887 191.399 44.6888 191.399 44.6889C191.399 44.6891 191.399 44.6892 192.333 43.6552C193.266 42.6212 193.266 42.6214 193.266 42.6215C193.266 42.6216 193.266 42.6217 193.266 42.6218C193.267 42.622 193.267 42.6222 193.267 42.6223C193.267 42.6226 193.268 42.6229 193.268 42.6231C193.268 42.6235 193.269 42.6238 193.269 42.6238C193.269 42.6238 193.268 42.623 193.266 42.6213C193.263 42.6181 193.256 42.6116 193.246 42.6022C193.227 42.5833 193.196 42.5529 193.157 42.5127C193.078 42.4316 192.969 42.3154 192.856 42.1786C192.599 41.8694 192.432 41.5936 192.383 41.4315L189.723 42.2311ZM191.437 44.5449L192.336 42.3911L189.769 41.2715L188.871 43.4254L191.437 44.5449ZM192.333 43.6552C192.278 42.2477 192.278 42.2477 192.278 42.2478C192.278 42.2478 192.278 42.2478 192.278 42.2478C192.277 42.2478 192.277 42.2478 192.277 42.2478C192.276 42.2478 192.276 42.2478 192.275 42.2478C192.274 42.2479 192.272 42.2479 192.27 42.248C192.266 42.2481 192.26 42.2483 192.254 42.2485C192.24 42.249 192.222 42.2497 192.199 42.2506C192.153 42.2525 192.088 42.2556 192.009 42.2601C191.851 42.2692 191.631 42.2847 191.383 42.3104C190.921 42.3582 190.232 42.4531 189.666 42.6611L190.642 45.3093C190.868 45.2263 191.268 45.1563 191.697 45.1118C191.895 45.0914 192.071 45.0789 192.198 45.0716C192.261 45.068 192.311 45.0657 192.344 45.0643C192.36 45.0636 192.373 45.0632 192.38 45.0629C192.384 45.0628 192.386 45.0627 192.387 45.0627C192.388 45.0627 192.388 45.0626 192.388 45.0626C192.388 45.0626 192.388 45.0627 192.388 45.0627C192.388 45.0627 192.388 45.0627 192.387 45.0627C192.387 45.0627 192.387 45.0627 192.387 45.0627C192.387 45.0627 192.387 45.0627 192.333 43.6552Z"
        fill="#1D2943"
        mask="url(#path-208-inside-2_241_11808)"
      />
      <path
        d="M159.624 67.3066C157.744 68.0309 155.417 71.22 153.999 75.3181C152.227 80.44 152.432 85.1581 154.447 85.8555C154.786 85.9661 155.15 85.9718 155.492 85.8719L156.136 85.5888C155.805 85.9899 155.389 86.313 154.919 86.5351C154.448 86.7571 153.934 86.8727 153.413 86.8734H148.954C146.327 86.8734 143.814 84.8541 143.811 82.232C143.805 78.581 147.692 66.8178 155.454 64.6816C158.083 63.9581 161.769 64.6629 162.058 66.6792L159.624 67.3066Z"
        fill="#F9F9FF"
        stroke="#2E3860"
        stroke-width="1.4"
      />
      <path
        d="M155.493 85.8732C155.151 85.9731 154.787 85.9674 154.448 85.8568C152.426 85.1594 152.225 80.4413 154 75.3194C155.418 71.2213 157.746 68.0322 159.625 67.3079L182.51 61.3857C182.944 61.1853 184.238 61.1562 184.717 61.1562H190.647V61.5072C190.647 61.9788 190.481 62.4355 190.177 62.7968C189.874 63.1582 189.452 63.4013 188.987 63.4832L187.483 63.8715C187.17 63.9266 186.873 64.0516 186.614 64.2371C186.356 64.4226 186.142 64.6638 185.99 64.9429L184.1 68.8563C183.796 69.4136 183.704 70.3827 184.34 70.3827L186.614 71.5455L189.183 72.8525C189.183 72.8525 189.555 73.7942 182.667 75.2531L178.297 75.8529L155.493 85.8732Z"
        fill="#C9A2A3"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M185.267 66.4385C184.361 68.0606 182.823 70.138 180.8 70.3749"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M176.228 74.3848C176.476 74.8656 176.868 75.2569 177.35 75.504C177.832 75.751 178.379 75.8414 178.915 75.7625"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M79.6596 80.2598L79.6597 80.2596C80.5365 78.5975 81.7675 76.89 83.1554 75.3676C85.4306 72.8724 88.0615 71.1779 90.4477 70.4336C92.8519 69.6836 94.8668 69.9295 96.1162 71.0634C96.507 71.4209 96.9455 72.1808 96.9907 73.5667L86.687 86.6499H83.2949C80.2496 86.6499 78.1927 83.0386 79.6596 80.2598Z"
        fill="white"
        stroke="#2E3860"
        stroke-width="1.4"
      />
      <path
        d="M86.8431 87.1878C85.5855 86.1237 86.9237 81.8125 89.8286 78.385C91.9259 75.9134 94.3433 74.1892 96.001 73.8182C96.1279 73.807 96.2496 73.8018 96.366 73.8018H103.233C106.045 73.8015 108.807 74.5456 111.237 75.9581L116.141 78.8067C116.737 79.1749 117.23 79.6892 117.571 80.3006C117.912 80.9121 118.092 81.6005 118.092 82.3005V88.9142C118.092 89.771 117.775 90.5977 117.203 91.2363C116.631 91.8748 115.843 92.2803 114.99 92.3753L110.102 92.9192V91.8634C110.102 91.562 110.177 91.2654 110.32 91.0001C110.464 90.7349 110.671 90.5095 110.923 90.3441L112.1 89.704C112.151 89.6762 112.191 89.6323 112.214 89.5792C112.237 89.5261 112.242 89.4668 112.228 89.4107C112.213 89.3546 112.181 89.3048 112.135 89.2693C112.089 89.2338 112.033 89.2145 111.975 89.2145H110.498C108.463 89.2145 106.883 88.643 105.428 87.2228L88.6225 87.1975L86.8431 87.1878Z"
        fill="#C9A2A3"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M113.344 82.6665L115.987 84.2991C116.583 84.6674 117.075 85.1817 117.416 85.7931C117.758 86.4046 117.937 87.0929 117.937 87.7929V89.839"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M113.344 79.9102L115.987 81.5427C116.583 81.9114 117.076 82.4262 117.417 83.0384C117.759 83.6505 117.937 84.3397 117.937 85.0403V87.6825"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M117.851 90.107C117.627 88.8634 117.03 87.8955 116.06 87.2964L113.417 85.6631"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M104.923 85.3252C104.923 85.8939 105.074 86.4525 105.361 86.9441C105.647 87.4357 106.059 87.8428 106.554 88.1239"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M58.5027 89.3389H34.048C31.9932 89.3389 30.3274 91.0019 30.3274 93.0533V114.386C30.3274 116.437 31.9932 118.1 34.048 118.1H58.5027C60.5575 118.1 62.2233 116.437 62.2233 114.386V93.0533C62.2233 91.0019 60.5575 89.3389 58.5027 89.3389Z"
        fill="#9090C7"
      />
      <path
        d="M53.8753 89.5474H33.1525C31.0977 89.5474 29.4319 91.2104 29.4319 93.2618V114.177C29.4319 116.229 31.0977 117.892 33.1525 117.892H53.8753C55.9302 117.892 57.596 116.229 57.596 114.177V93.2618C57.596 91.2104 55.9302 89.5474 53.8753 89.5474Z"
        fill="white"
        stroke="#1D2943"
        stroke-width="1.4"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.4319 93.2617H62.2242"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M160.02 186.907C177.725 186.907 192.078 172.578 192.078 154.903C192.078 137.227 177.725 122.898 160.02 122.898C142.315 122.898 127.962 137.227 127.962 154.903C127.962 172.578 142.315 186.907 160.02 186.907Z"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M160.02 184.707C176.508 184.707 189.874 171.363 189.874 154.903C189.874 138.442 176.508 125.098 160.02 125.098C143.532 125.098 130.165 138.442 130.165 154.903C130.165 171.363 143.532 184.707 160.02 184.707Z"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M40.0579 186.907C57.7629 186.907 72.1157 172.578 72.1157 154.903C72.1157 137.227 57.7629 122.898 40.0579 122.898C22.3528 122.898 8 137.227 8 154.903C8 172.578 22.3528 186.907 40.0579 186.907Z"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M40.058 184.707C56.5462 184.707 69.9126 171.363 69.9126 154.903C69.9126 138.442 56.5462 125.098 40.058 125.098C23.5697 125.098 10.2034 138.442 10.2034 154.903C10.2034 171.363 23.5697 184.707 40.058 184.707Z"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M131.979 96.5693H172.271L168.637 107.929C168.37 108.762 167.845 109.49 167.137 110.006C166.429 110.522 165.575 110.8 164.698 110.8H138.77L131.979 96.5693Z"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M169.211 96.5693L165.577 107.929C165.31 108.762 164.785 109.49 164.077 110.006C163.369 110.522 162.515 110.8 161.638 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M165.95 96.5693L162.316 107.929C162.049 108.762 161.524 109.49 160.816 110.006C160.108 110.522 159.254 110.8 158.377 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M162.689 96.5693L159.055 107.929C158.788 108.762 158.263 109.49 157.555 110.006C156.847 110.522 155.993 110.8 155.116 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M159.426 96.5693L155.792 107.929C155.525 108.762 155 109.49 154.292 110.006C153.584 110.522 152.73 110.8 151.854 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M156.165 96.5693L152.531 107.929C152.264 108.762 151.739 109.49 151.031 110.006C150.323 110.522 149.469 110.8 148.593 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M152.903 96.5693L149.269 107.929C149.002 108.762 148.477 109.49 147.769 110.006C147.061 110.522 146.207 110.8 145.33 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M149.641 96.5693L146.007 107.929C145.74 108.762 145.215 109.49 144.507 110.006C143.799 110.522 142.945 110.8 142.068 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M146.379 96.5693L142.745 107.929C142.479 108.762 141.953 109.49 141.246 110.006C140.538 110.522 139.684 110.8 138.807 110.8"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M143.118 96.5693L139.484 107.929C139.256 108.64 138.84 109.276 138.278 109.77"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M139.856 96.5693L136.703 106.428"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M136.595 96.5693L134.743 102.36"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M123.28 154.951C123.28 134.696 139.728 118.276 160.017 118.276"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M143.829 113.125C135.93 115.853 128.671 122.195 124.391 129.965L119.308 139.189C116.691 143.938 112.845 147.899 108.171 150.658C103.497 153.417 98.1675 154.872 92.7378 154.873H81.1281L67.8547 111.997"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M160.02 154.903L130.416 93.4263C129.801 92.1464 128.835 91.0661 127.631 90.3099C126.428 89.5537 125.034 89.1525 123.612 89.1523H122.033C121.06 89.1526 120.104 89.4042 119.258 89.8828C118.412 90.3614 117.705 91.0506 117.205 91.8832L116.186 93.5821"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M58.4534 118.246C58.4532 117.231 58.0492 116.258 57.3304 115.54C56.6115 114.822 55.6366 114.419 54.62 114.419H32.9874C31.9708 114.419 30.9959 114.822 30.277 115.54C29.5582 116.258 29.1543 117.231 29.1541 118.246V118.276H61.9404C63.3477 118.275 64.7185 118.723 65.8535 119.554C66.9885 120.385 67.8285 121.555 68.2516 122.895L37.3387 154.903"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M159.997 156.424C160.831 156.424 161.507 155.749 161.507 154.916C161.507 154.083 160.831 153.408 159.997 153.408C159.162 153.408 158.486 154.083 158.486 154.916C158.486 155.749 159.162 156.424 159.997 156.424Z"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M90.3477 162.49C90.291 166.536 86.9831 169.839 82.9296 169.896C81.9322 169.91 80.9419 169.727 80.0163 169.356C79.0907 168.984 78.2482 168.433 77.5378 167.734C76.8274 167.035 76.2633 166.202 75.8783 165.283C75.4933 164.365 75.295 163.379 75.295 162.383V162.351C75.299 161.967 75.227 161.587 75.0829 161.231C74.9389 160.876 74.7257 160.552 74.4557 160.279C74.1857 160.006 73.8643 159.789 73.5099 159.641C73.1555 159.492 72.7752 159.415 72.3909 159.415H36.396C35.1607 159.415 34.1195 158.446 34.0912 157.212C34.0842 156.911 34.1375 156.612 34.248 156.332C34.3584 156.053 34.5237 155.797 34.7343 155.582C34.9448 155.367 35.1963 155.196 35.474 155.079C35.7516 154.963 36.0499 154.902 36.3512 154.902H82.1101C82.3444 154.88 82.5815 154.869 82.8213 154.869C83.8188 154.869 84.8064 155.067 85.7265 155.451C86.6467 155.836 87.4812 156.399 88.1815 157.108C88.8817 157.817 89.4338 158.658 89.8057 159.582C90.1776 160.506 90.3618 161.495 90.3477 162.49Z"
        fill="white"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M82.8215 166.618C85.1241 166.618 86.9907 164.755 86.9907 162.456C86.9907 160.157 85.1241 158.294 82.8215 158.294C80.519 158.294 78.6523 160.157 78.6523 162.456C78.6523 164.755 80.519 166.618 82.8215 166.618Z"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M82.821 162.457L86.9261 172.9C86.9908 173.064 87.1038 173.206 87.2503 173.305C87.3968 173.405 87.5699 173.458 87.7471 173.457H97.9782"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.4228 158.659C37.2571 158.659 37.9334 157.984 37.9334 157.151C37.9334 156.318 37.2571 155.643 36.4228 155.643C35.5884 155.643 34.9121 156.318 34.9121 157.151C34.9121 157.984 35.5884 158.659 36.4228 158.659Z"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M98.1931 171.677H87.7089C87.3944 171.677 87.1394 171.931 87.1394 172.245V172.888C87.1394 173.202 87.3944 173.457 87.7089 173.457H98.1931C98.5076 173.457 98.7625 173.202 98.7625 172.888V172.245C98.7625 171.931 98.5076 171.677 98.1931 171.677Z"
        stroke="#004360"
        stroke-width="1.4"
        stroke-miterlimit="10"
      />
      <path
        d="M76.5443 111.997H63.9636C63.3921 111.997 62.844 111.77 62.4399 111.367C62.0359 110.963 61.8088 110.416 61.8088 109.845C61.8088 109.275 62.0359 108.728 62.4399 108.324C62.844 107.921 63.3921 107.694 63.9636 107.694H82.2361C82.3108 107.694 82.3839 107.716 82.4459 107.758C82.5079 107.799 82.556 107.859 82.5839 107.928C82.6117 107.997 82.6182 108.073 82.6024 108.146C82.5866 108.219 82.5492 108.285 82.4951 108.337L80.2284 110.514C79.2387 111.465 77.9182 111.997 76.5443 111.997Z"
        fill="#004360"
      />
      <path
        d="M12.676 187.29L235.615 187.555"
        stroke="#1D2943"
        stroke-width="1.4"
        stroke-miterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default D2DEmptyState
